import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import './ReadOnlyLinkWithEditLink.scss';

class ReadOnlyInputWithEditLink extends Component {
  constructor(props) {
    super(props);
    this.state = { isEditing: false, value: props.value };
    this.cancelEditing = this.cancelEditing.bind(this);
    this.startEditing = this.startEditing.bind(this);
    this.updateInputField = this.updateInputField.bind(this);
  }

  cancelEditing(event) {
    event.preventDefault();
    this.setState({ isEditing: false, value: this.props.value });
  }

  startEditing(event) {
    event.preventDefault();
    this.setState({ isEditing: true });
  }

  updateInputField(event) {
    this.setState({ value: event.target.value });
  }

  render() {
    let input = null;
    let link = null;
    if (this.state.isEditing) {
      input = (
        <input
          type={this.props.inputType}
          value={this.state.value}
          onChange={this.updateInputField}
          name={this.props.name}
          className="form-control"
        />
      );
      link = (<a href="# " className="btn" onClick={this.cancelEditing}>Cancel</a>);
    } else {
      const props = {
        type: this.props.inputType,
        name: this.props.name,
        value: this.props.value,
        className: 'disabled form-control',
      };

      if (this.props.disabled) {
        props.disabled = 'disabled';
      } else {
        props.readOnly = 'readonly';
      }

      input = (<input {...props} />);
      link = (<a href="# " className="btn" onClick={this.startEditing}>Edit</a>);
    }

    return (
      <Row className="readonly-input-with-edit-link">
        <Col xs={8}>{input}</Col>
        <Col xs={1}>{link}</Col>
      </Row>
    );
  }
}

ReadOnlyInputWithEditLink.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  inputType: PropTypes.string,
};

ReadOnlyInputWithEditLink.defaultProps = {
  value: '',
  disabled: false,
  inputType: 'text',
};

export default ReadOnlyInputWithEditLink;
